<template>
  <a-modal
    :open="open"
    class="portfolios"
    title="Detalles del conector de API"
    width="550px"
    centered
    @cancel="handleClose"
    :maskClosable="false"
    :footer="null"
  >
    <a-divider class="divider" />
    <div class="container">
      <CustomScrollbar height="calc(100% - 50px)" class="scrollbar" auto>
        <p class="title">
          Información general
        </p>
        <div class="details">
          <p class="subtitle">Nombre del conector de API:</p>
          <span>{{ connector?.name }}</span>
        </div>
        <div class="details">
          <p class="subtitle">Descripción:</p>
          <span>{{ connector?.description }}</span>
        </div>
        <div class="details">
          <p class="subtitle">Tipo de petición:</p>
          <span>{{ RequestTypeText[connector?.type_request as RequestType] || '-'}}</span>
        </div>
        <div class="details">
          <p class="subtitle">URL de API Server:</p>
          <span>{{ connector?.url || '-'}}</span>
        </div>
        <div class="details">
          <p class="subtitle">Tipo de autenticación:</p>
          <span>
            {{ AuthenticationTypeName[connector?.type_authentication as AuthenticationType] || '-'}}
          </span>
        </div>
        <div class="details" v-if="connector.type_authentication == AuthenticationType.APIKey">
          <p class="subtitle">API Key de autenticación:</p>
          <span>●●●●●●●●●●●●●●●●</span>
        </div>
        <div v-else-if="connector.type_authentication == AuthenticationType.Token">
          <div class="details">
            <p class="subtitle">Token de autenticación:</p>
            <span>{{ connector?.url_token || '-' }}</span>
          </div>
          <div class="details">
            <p class="subtitle">Nombre de usuario:</p>
            <span>{{ connector?.username_token || '-' }}</span>
          </div>
          <div class="details">
            <p class="subtitle">Contraseña:</p>
            <span>●●●●●●●●</span>
          </div>
        </div>
        <div v-else-if="connector.type_authentication == AuthenticationType.BasicAuth">
          <div class="details">
            <p class="subtitle">Nombre de usuario:</p>
            <span>{{ connector?.username || '-' }}</span>
          </div>
          <div class="details">
            <p class="subtitle">Contraseña:</p>
            <span>●●●●●●●●</span>
          </div>
        </div>
        

        <a-divider />

        <p class="title">Configuración</p>
        <div class="details">
          <p class="subtitle">Nombre del parámetro a capturar del IVR:</p>
          <span>{{ connector?.ivr_param_name || '-' }}</span>
        </div>

        <div class="details">
          <p class="subtitle">Propiedades estándar para enviar al API ({{ countProperties }}):</p>
          <a-table
            :columns="columns"
            :data-source="props.connector?.standard_properties"
            row-key="name"
            :pagination="false"
          />
        </div>

        <div class="details">
          <p class="subtitle">Nombre del campo a devolver del API:</p>
          <span>{{ connector?.api_return_field || '-' }}</span>
        </div>
        <div class="details">
          <p class="subtitle">Tipo de dato:</p>
          <span>{{ ResponseTypesText[connector?.data_type as ResponseType] || '-' }}</span>
        </div>
        <div class="details" v-if="connector?.data_type != ResponseType.String">
          <p class="subtitle">Valores del tipo numérico:</p>
          <span v-if="connector?.data_type == ResponseType.Boolean">
            Verdadero/Falso
          </span>
          <span v-else>
            {{ connector?.data_value?.join(",") || '-' }}
          </span>
        </div>
      </CustomScrollbar>
      
      <div class="footer">
        <a-button @click="handleClose">
          Cerrar detalles
        </a-button>
      </div>
    </div>
    
  </a-modal>
</template>

<script setup lang="ts">
import { computed } from "vue";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import { Connector } from "@/@types/ivr";
import { AuthenticationType, AuthenticationTypeName, RequestType, RequestTypeText, ResponseType, ResponseTypesText, SendType, SendTypeText } from "../../utils/enums";

const props = defineProps<{
  connector: Connector;
  open: boolean;
}>();

const emit = defineEmits<{ "update:open": [open: boolean]; update: [] }>();

const handleClose = () => emit("update:open", false);

const countProperties = computed(
  () => Object.keys(props.connector?.standard_properties ?? {}).length
);

const columns = [
  {
    title: "Nombre del campo",
    dataIndex: "name",
    key: "name"
  },
  {
    title: "Valor",
    dataIndex: "value",
    key: "value"
  },
  {
    title: "Tipo de envío",
    dataIndex: "send_type",
    key: "send_type",
    customRender: ({ text }) => SendTypeText[text as SendType] ?? text
  }
];
</script>

<style scoped lang="sass">
.title
  font-weight: 600
  font-size: 18px
  margin-bottom: 20px
.details
  margin-bottom: 15px
.subtitle
  font-weight: 600
  margin-bottom: 3px
.type
  font-size: 12px
  color: $text-secondary
  line-height: 20px
.name
  font-weight: 600
  font-size: 16px
  color: $gray-9
  margin-bottom: 2px
.description
  font-weight: 400
  font-size: 14px
  color: $gray-8
  .count
    color: $primary
    font-weight: 500
.properties
  &__list
    padding-inline-start: 25px
    color: $gray-9
    li
      margin-top: 10px
      font-weight: 600
    .tag
      margin-left: 6px
      font-weight: 400
.footer
  display: flex
  align-items: center
  justify-content: center
  padding: 15px 20px
  border-top: $border-normal
  position: absolute
  width: 100%
  bottom: 0
  left: 0

.container
  height: 580px
  max-height: auto
  padding-top: 20px

.required
  color: $red-6
  margin-left: 6px

.divider
  position: absolute
  left: 0
  top: 45px
  margin: 10px 0

.scrollbar
  padding-right: 5px
</style>
